<template>
    <v-list two-line
            subheader>
        <v-subheader inset>FAQ</v-subheader>
        <v-list-tile v-for="item in items"
                     :key="item.title"
                     avatar>
            <v-list-tile-avatar>
                <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
            </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar>
            <v-btn flat
                   outline
                   class="teal--text darken-2">Kangaruu</v-btn>
            <v-list-tile-content>
                <v-list-tile-title>Home</v-list-tile-title>
                <v-list-tile-sub-title>Return to Inbox</v-list-tile-sub-title>
            </v-list-tile-content>
        </v-list-tile>

    </v-list>
</template>

<script>
export default {
  data () {
    return {
      items: [
        { icon: 'list_alt', iconClass: 'teal', title: 'Shipping Instructions', subtitle: 'Additional shiping items for broker.' },
        { icon: 'done', iconClass: 'teal', title: 'Finalize Shipment', subtitle: 'Remove shipment form inbox.' },
        { icon: 'account_circle', iconClass: 'teal', title: 'Add Broker', subtitle: 'Add an additional Broker to shipment.' },
        { icon: 'photo_camera', iconClass: 'teal', title: 'Upload File', subtitle: 'Upload bill of lading.' },
        { icon: 'attach_file', iconClass: 'teal', title: 'Download File', subtitle: 'Download bill of lading.' },
        { icon: 'assignment', iconClass: 'teal', title: 'Shipment details', subtitle: 'View shipment details.' },
        { icon: 'remove_circle_outline', iconClass: 'teal', title: 'Decline Shipment', subtitle: 'Remove yourself from the shipment.' }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/DetailHelp.vue